import BreadCrumbs from 'components/breadcrumbs'
import { useFetchAttendanceReportQuery } from '../reportAttendanceApiSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import TableSummary from 'features/private-views/attendance-summary/TableSummary'
import { useFetchAttendanceSummaryQuery } from 'features/private-views/attendance-summary/attendanceSummaryApiSlice'
import moment from 'moment-timezone'
import { setFetchOption } from '../../attendance-summary/attendanceSummarySlice'
import { act, useEffect } from 'react'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { setActiveTab } from '../reportAttendanceSlice'
import { setFetchOption as setFetchOption2 } from '../reportAttendanceSlice'
import TableReport from '../TableReport'

const TodayReport = () => {
  const dispatch = useDispatch()
  const from = moment().startOf('day').toISOString()
  const to = moment().add(1, 'day').startOf('day').toISOString()

  const { tag } = useSelector((s) => s.attendanceSummary)
  const { activeTab, tag: tagReport } = useSelector((s) => s.reportAttendance)

  const queryTagSummary = tag
    ? Object.fromEntries(
      Object.entries(tag).filter(
        ([key]) => key !== 'from' && key !== 'to' && key !== 'memberUserId',
      ),
    )
    : {}

  const queryTagReport = tagReport
    ? Object.fromEntries(
      Object.entries(tagReport).filter(
        ([key]) => key !== 'from' && key !== 'to' && key !== 'memberUserId',
      ),
    )
    : {}

  const res = useFetchAttendanceSummaryQuery(
    {
      ...queryTagSummary,
      notCheckIn: true,
      from: from,
      to: to,
    },
    { skip: !tagReport && activeTab === 'all' },
  )

  const reportQueryArgs = {
    ...queryTagReport,
    from: from,
    to: to,
  }
  const res2 = useFetchAttendanceReportQuery(reportQueryArgs, {
    skip: !tag && activeTab === 'absent',
  })

  const tabs = [
    { key: 'all', label: 'Hadir' },
    { key: 'absent', label: 'Tidak Hadir' },
  ]

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
    dispatch(setActiveTab(tabKey))
  }

  useEffect(() => {
    dispatch(
      setFetchOption({
        s: undefined,
      }),
    )
  }, [])

  useEffect(() => {
    dispatch(
      setFetchOption2({
        s: undefined,
        from: from,
        to: to,
      }),
    )
  }, [])

  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Laporan Hari Ini'} />
      </div>
      <div className="d-flex flex-column gap-2 mb-2">
        <Card className="border-0 shadow-sm">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Laporan Hari Ini</h5>
            </div>
            <div className="mb-2 d-flex justify-content-between flex-wrap">
              <PMBTabSwitcher
                activeTab={activeTab}
                tabs={tabs}
                onTabChange={handleTabChange}
                testId="attendance-report-tab"
              />
            </div>
            {activeTab === 'all' ? (
              <TableReport
                data={res2?.data}
                queryArgs={reportQueryArgs}
                loading={res2?.status === 'pending'}
                refetch={res2?.refetch}
                noPadding
                defaultDateRange={[
                  moment(from).format('YYYY-MM-DD'),
                  moment(to).subtract(1, 'day').format('YYYY-MM-DD'),
                ]}
              />
            ) : (
              <TableSummary
                res={res}
                noDate
                today
                noDetail
                defaultDateRange={[
                  moment(from).format('YYYY-MM-DD'),
                  moment(to).subtract(1, 'day').format('YYYY-MM-DD'),
                ]}
              />
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default TodayReport
